import { render, staticRenderFns } from "./RoomSearchInput.vue?vue&type=template&id=16565bf1&lang=pug&"
import script from "./RoomSearchInput.vue?vue&type=script&lang=ts&"
export * from "./RoomSearchInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomSearchInput.vue"
export default component.exports